var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body"},[_c('base-input',{attrs:{"data":_vm.adminForm}}),_c('the-footer',{attrs:{"divide":1,"first-button":{
      isPlain: false,
      type: 'success',
      class: 'align-right',
      classList: 'btn-success',
      trigger: {
        function: 'move',
        argument: 'save'
      },
      text: 'Next'
    }},on:{"click":function($event){("location.href=" + (_vm.app.url))},"move":function($event){return _vm.moveTo($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }